import { useMemo, useState } from 'react';

export interface Props {
  count: number;
  length: number;
  initialIndex?: number;
}

function useSlide(props: Props) {
  const { count, length, initialIndex = 0 } = props;

  const [index, setIndex] = useState(initialIndex);

  return useMemo(() => {
    const preDisabled = index <= 0;
    const nextDisabled = index + count >= length;

    const pre = () => {
      if (preDisabled) {
        return;
      }

      const next = index - count;

      setIndex(next >= 0 ? next : 0);
    };

    const next = () => {
      if (nextDisabled) {
        return;
      }

      const max = length - count;

      const next = index + count;

      setIndex(next <= max ? next : max);
    };

    return {
      index,
      preDisabled,
      nextDisabled,
      pre,
      next,
      setIndex,
    };
  }, [count, length, index]);
}

export default useSlide;
